import React, { Component } from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import styled, { css } from "styled-components"
import Slider from "react-slick"
import YouTube from 'react-youtube'
import getVideoId from "get-video-id"
import { Container, Row, Col } from "reactstrap"
import { media } from "utils/Media"
import WPLink from "components/shared/WPLink"
// import Image from "components/shared/Image"
import YoutubeVideoOverlay from "components/shared/YoutubeVideoOverlay"
import Button from "components/shared/Button"
import { LinkSearchReplace } from "utils/LinkSearchReplace"

const SliderStyled = styled(Slider)`
    position: relative;

    .slick-slide {
        > div {
            display: flex;
        }
    }
    
    .slick-arrow {
        display: none !important;

        @media ${media.sm} {
            display: block !important;
        }
    }

    .slick-prev {
        left: 1.5rem;
    }

    .slick-next {
        right: 1.5rem;
        @media ${media.md} {
            right: 3.5rem;
        }
    }

    .slick-dots {
        /* calc height of image responsively */
        top: calc((((324 / 576) * 100vw)) - 2.5rem); 
        bottom: auto;

        @media ${media.sm} {
            top: calc((((775 / 992) * 100vw)) - 2.5rem); 
        }

        @media ${media.md} {
            top: auto;
            bottom: 1.5rem;
        }
    }
`

const Slide = styled.div`
    display: block;
    position: relative;
    overflow: hidden;

    ${props => props.$overlay && css`
        &:after {
            content: "";
            position: absolute;
            z-index: 2;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            background-image: linear-gradient(to right, rgba(50,55,65, .65), rgba(50,55,65, 0));
            display:none;
            
            @media ${media.md} {
                display:block;
            }
        }
    `}

`

const SlideContainer = styled(Container)`
    background-color: ${props => props.theme.colors.blackOff};
    padding-top: 2rem;
    padding-bottom: 2rem;

    @media ${media.sm} {
        background-color: transparent;
        position: absolute;
        z-index: 10;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    h1 {
        color: ${props => props.theme.colors.white};
        font-family: ${props => props.theme.font.family.atp};
        text-transform: uppercase;
        margin-bottom: .5rem; 
    }

    h2 {
        color: ${props => props.theme.colors.white};
        font-size: ${props => props.theme.font.size.md};
        font-family: ${props => props.theme.font.family.dinMedium};
        text-transform: uppercase;
        margin-bottom: .5rem; 
    }
`

const TextBlock = styled.div`
    color: ${props => props.theme.colors.white};
    padding: 1rem 0 2rem 0;
`

const TitleStrip = styled.div`
    background-color: ${props => props.theme.colors.primary};
    padding: 1rem;
    h1 {
        color: white;
        text-align: center;
        margin: 0;
        padding: 0;
    }
`

const VideoWrap = styled.div`
    position: absolute;
    z-index: 1;
    top: -20%;
    left: -20%;
    width: 140%;
    height: 140%;
    display: none;

    iframe {
        pointer-events: none;
    }

    @media ${media.md} {
        display: block;
    }
`

const WPLinkStyled = styled(WPLink)`
    padding: 1rem;
    font-size: .7rem;
    width: 100%;
    text-align: center;

    @media ${media.sm} {
        width: auto;
    }

    @media ${media.md} {
        padding: 1rem 2rem;
        font-size: ${props => props.theme.font.size.base};
    }
`

class Carousel extends Component {

    constructor(props) {
        super(props)

        this.state = {
            players: []
        }

        this.onReady = this.onReady.bind(this)
        this.onSlide = this.onSlide.bind(this)
    }

    onReady(e, slideIndex) {
        // Pause other videos
        if (slideIndex !== 0) e.target.pauseVideo()

        let { players } = this.state
        players[slideIndex] = e.target

        e.target.playVideo()

        this.setState({
            players
        })
    }

    onSlide(current, next) {
        if (this.state.players[current] !== undefined) {
            this.state.players[current].pauseVideo()
        }
        if (this.state.players[next] !== undefined) {
            this.state.players[next].playVideo()
        }
    }

    render() {
        let videoId
        let opts

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            fade: true,
            autoplay: 0,
            adaptiveHeight: true,
            beforeChange: (current, next) => this.onSlide(current, next)
        }

        if (this.props.slides !== null) {
            return (
                <SliderStyled {...settings}>
                    {this.props.slides.map((slide, i) => {

                        if (slide.backgroundVideo !== null) {
                            videoId = getVideoId(slide.backgroundVideo).id
                            opts = {
                                playerVars: { // https://developers.google.com/youtube/player_parameters
                                    autoplay: 0,
                                    controls: 0,
                                    autohide: 1,
                                    rel: 0,
                                    modestbranding: 1,
                                    showinfo: 0,
                                    loop: 1,
                                    playlist: videoId,
                                    mute: 1,
                                    playsinline: 1
                                }
                            }
                        }

                        return (
                            <Slide key={i} $overlay={slide.overlayTint}>
                                {slide.imageMobile !== null &&
                                    // <Image data={slide.imageMobile} className="d-sm-none" fullWidth={true} lazyload={false} />    
                                    <GatsbyImage
                                        image={slide.imageMobile.localFile.childImageSharp.gatsbyImageData}
                                        className="d-sm-none"
                                        alt={slide.imageMobile.altText} />    
                                }
                                {slide.imageTablet !== null &&
                                    // <Image data={slide.imageTablet} className="d-none d-sm-block d-lg-none" fullWidth={true} lazyload={false} />    
                                    <GatsbyImage
                                        image={slide.imageTablet.localFile.childImageSharp.gatsbyImageData}
                                        className="d-none d-sm-block d-lg-none"
                                        alt={slide.imageTablet.altText} />    
                                }
                                {slide.imageDesktop1 !== null &&
                                    // <Image data={slide.imageDesktop} className="d-none d-lg-block" fullWidth={true} lazyload={false}/>    
                                    <GatsbyImage
                                        image={slide.imageDesktop.localFile.childImageSharp.gatsbyImageData}
                                        className="d-none d-lg-block"
                                        alt={slide.imageDesktop.altText} />    
                                }
                                {slide.backgroundVideo !== null &&
                                    <VideoWrap className="embed-responsive embed-responsive-16by9">
                                        <YouTube
                                            videoId={videoId}
                                            opts={opts}
                                            onReady={(e) => this.onReady(e, i)}
                                            className="embed-responsive-item"
                                        />
                                    </VideoWrap>
                                }
                                {slide.title && (slide.subTitle || slide.text || slide.link1 || slide.link2 || slide.linkVideo) && (
                                 <SlideContainer>
                                    <Row>
                                        <Col md={10} lg={6}>
                                            {slide.subTitle !== null &&
                                                <h2>{slide.subTitle}</h2>
                                            }

                                            {slide.title !== null && !slide.titleAsStrip &&
                                                <h1>{slide.title}</h1>
                                            }

                                            {slide.text !== null &&
                                                <TextBlock dangerouslySetInnerHTML={{ __html: LinkSearchReplace(slide.text) }} />
                                            }

                                            <Row>
                                                {slide.link1 && slide.link1.url !== "" &&
                                                    <Col xs={6} sm="auto">
                                                        <WPLinkStyled url={slide.link1.url} target={slide.link1.target} button color="primary">
                                                            {slide.link1.title}
                                                        </WPLinkStyled>
                                                    </Col>
                                                }
                                                {slide.link2 && slide.link2.url !== "" &&
                                                    <Col xs={6} sm="auto">
                                                        <WPLinkStyled url={slide.link2.url} target={slide.link2.target} button color="transparentWhite">
                                                            {slide.link2.title}
                                                        </WPLinkStyled>
                                                    </Col>
                                                }

                                                {/*do we have a link to a youtube video?*/}
                                                {slide.linkVideo &&
                                                    <Col xs={6} sm="auto">
                                                        <YoutubeVideoOverlay oembed={slide.linkVideo}>
                                                            <Button color="primary" as="button">Watch</Button>
                                                        </YoutubeVideoOverlay>
                                                    </Col>
                                                }
                                            </Row>
                                        </Col>
                                    </Row>
                                </SlideContainer>
                               )}
                               {slide.titleAsStrip && slide.title && (
                                <TitleStrip>
                                    <h1>{slide.title}</h1>
                                </TitleStrip>
                               )}
                            </Slide>
                        );
                    })}
                </SliderStyled>
            );
        } else {
            return ""
        }
    }
}

export default Carousel